import { render, staticRenderFns } from "./preview-unavailable.vue?vue&type=template&id=2ed2c25c"
import script from "./preview-unavailable.vue?vue&type=script&lang=js"
export * from "./preview-unavailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports